/*
 * Public API Surface of ngx-filesize
 */

export * from './lib/ngx-filesize.module';
export * from './lib/filesize.pipe';
